import {Box, Button, Divider, Flex, Text} from '@chakra-ui/react';
import {IconBlock} from 'components/layouts/aside-layout';
import {colors} from 'components/providers';
import {Checkbox} from 'components/shared';
import {FC} from 'react';
import {TranslationKeys} from 'translations';
import {MaibCardItem} from 'types';
import ImageUI from 'ui/ImageUI';
import {validateCardType} from 'utils/cartUtils';

interface Props {
  card: MaibCardItem;
  onSelect: () => void;
  isSelected: boolean;
  onRemove: () => void;
  withBorder?: boolean;
  t: (term: TranslationKeys) => string;
}

export const CardItem: FC<Props> = ({card, onSelect, isSelected, onRemove, withBorder = false, t}) => {
  const title = card.masked_card_number;
  const cardType = validateCardType(card?.masked_card_number);
  const icon = cardType === 'VISA' ? '/icons/myCardsVisa.svg' : '/icons/myCardsMasterCard.svg';

  const isNewCard = card.id === 0;
  return (
    <Box border={withBorder ? '1px solid' : ''} borderColor={colors.borderGray} borderRadius="16px">
      <IconBlock icon={isNewCard ? '/icons/addNewCard.svg' : icon} position="relative">
        <Flex alignItems="flex-start">
          <Flex flexDirection="column" pr="30px" maxW="280px">
            <Text fontSize="14px" fontWeight="600" mb="5px">
              {title}
            </Text>
            {isSelected && !isNewCard ? (
              <Text fontSize="14px" fontWeight="500" color={colors.textGray}>
                {t('selectedCardDetails')}
              </Text>
            ) : null}
          </Flex>
          {isNewCard ? null : (
            <Button
              onClick={onRemove}
              borderRadius="9999px"
              alignSelf="flex-start"
              minW="30px"
              h="30px"
              p="0"
              position="absolute"
              top="1rem"
              right="1rem"
            >
              <ImageUI src="/delete-icon.svg" alt="Delete icon" />
            </Button>
          )}
        </Flex>
        <Divider my="15px" />
        <Flex justifyContent="flex-start" alignItems="center">
          <Checkbox variant="circle" isChecked={isSelected} onChange={onSelect}>
            <Text fontSize="14px" fontWeight="600">
              {t('SELECT')}
            </Text>
          </Checkbox>
        </Flex>
      </IconBlock>
    </Box>
  );
};
